import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import Button from '@components/Button';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import usePrepaidCharge from './hooks/usePrepaidCharge';
import { MAX_BALANCE_WON } from '../../../_shared/constants';
import useDailyMaxMan from '../../../_shared/hooks/useDailyMaxMan';

interface Props {
    id: string;
    agreed: boolean;
}

function PrepaidCardChargeFooter({ id, agreed }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount } = useContext(PrepaidContext);
    const { data } = useQuery(userPrepaidCardQueries.detail(id));
    const { handleCharge, isPending } = usePrepaidCharge(id);
    const balance = data?.balance ?? 0;
    const dailyMaxMan = useDailyMaxMan();
    const isInvalid = amount <= 0
        || amount > dailyMaxMan
        || balance + amount * 10000 > MAX_BALANCE_WON;

    return (
        <Button fullWidth
            onClick={handleCharge}
            disabled={isPending || !data || !agreed || isInvalid}>
            {t('charge.submit')}
        </Button>
    );
}

export default PrepaidCardChargeFooter;
